import React, { useState } from 'react';
import useChatStore from '../store/useChatStore';

const LoginPage = () => {
  const { setCurrentScreen } = useChatStore();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleLogin = () => {
    // if (name && email) {
    //   // signIn(); // Simulate user signing in
    //   setCurrentScreen('otp'); // Redirect to the order list
    // } else {
    //   alert('Please fill in all fields'); // Basic validation
    // }

    setCurrentScreen('otp');
  };

  return (
    <div className="login-page">
      <h2>Welcome</h2>
      <p style={{ marginBottom: '20px' }}>Please add your information below to get started!</p>

      {/* Name Input */}
      <input
        type="text"
        placeholder="Enter your name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="form-input"
      />

      {/* Email Input */}
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
        style={{ marginBottom: 0 }}
      />

      {/* Start Chat Button */}
      <button onClick={handleLogin} className="form-button">
        Start Chat
      </button>

      {/* Disclaimer Text */}
      <p className="login-disclaimer">
        You are signing up to receive communication via email and can unsubscribe at any time.
      </p>
    </div>
  );
};

export default LoginPage;
